module.exports = wtr_shared_18_16_0;